import RequestTransferReceiverPanel from "./requestTransferReceiverPanel.container";
export default RequestTransferReceiverPanel;
